export default __webpack_public_path__ + "static/media/ic_clock_primary.4a448f7b.svg";